/**
 * SportsCategoryNav — persistent chip bar that appears on every
 * /sports/* page so users always know where they are and can
 * jump between top-level buckets.
 */
import { Link, NavLink } from "react-router-dom";
import { Trophy, Users, Calendar, Home } from "lucide-react";

const TABS = [
  { to: "/sports",                key: "home",         label: "Home",         icon: Home,      exact: true },
  { to: "/sports/tournaments",    key: "tournaments",  label: "Tournaments",  icon: Trophy },
  { to: "/sports/clubs",          key: "clubs",        label: "Teams & Clubs",icon: Users },
  { to: "/sports/categories",     key: "categories",   label: "Categories",   icon: Calendar },
];

export default function SportsCategoryNav() {
  return (
    <nav
      className="sticky top-0 z-20 backdrop-blur-md border-b overflow-x-auto"
      style={{ background: "rgba(253,251,247,0.85)", borderColor: "var(--wofy-border)" }}
      data-testid="sports-nav"
    >
      <div className="max-w-6xl mx-auto flex items-center gap-1 px-3 py-2">
        <Link to="/sports" className="inline-flex items-center gap-1 text-xs opacity-70 hover:opacity-100 pr-2 md:pr-3 border-r"
              style={{ borderColor: "var(--wofy-border)" }} data-testid="sports-nav-brand">
          <Trophy className="w-3.5 h-3.5" /> Sports
        </Link>
        {TABS.map(({ to, key, label, icon: Icon, exact }) => (
          <NavLink
            key={key} to={to} end={exact}
            className={({ isActive }) =>
              `whitespace-nowrap inline-flex items-center gap-1 text-xs px-2.5 py-1.5 rounded-full transition ${
                isActive ? "bg-black text-white" : "hover:bg-black/5"
              }`
            }
            data-testid={`sports-nav-${key}`}
          >
            <Icon className="w-3.5 h-3.5" />{label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
